/* Phonelyne — Lyne Wallet and referrals on the website.
 *
 * Loaded only when Theme settings > "Enable Lyne Wallet and referrals on the
 * website" is on (snippets/lyne-config.liquid). Progressive enhancement: every
 * element it touches is hidden or unchanged until this script decides to show
 * it, so with JS off, or without the app's marker, the site is unchanged.
 *
 * pl_hint marker: set by app.phonelyne.com on .phonelyne.com, URL-encoded JSON
 *   { first_name, wallet: { amount, currency, display } | null, code }
 * It is not a login token and is only ever used for display. Nothing here
 * sends it anywhere. See docs/WEBSITE-PERSONAS.md.
 */
(function () {
  'use strict';

  var cfg = {};
  try {
    var cfgEl = document.getElementById('LyneConfig');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent) || {};
  } catch (e) { cfg = {}; }

  var WALLET = cleanText(cfg.walletName, 40) || 'Lyne Wallet';
  var APP_URL = String(cfg.appUrl || 'https://app.phonelyne.com').replace(/\/+$/, '');
  var API_URL = String(cfg.apiUrl || '').replace(/\/+$/, '');

  // ---------------------------------------------------------------- helpers

  function cleanText(v, max) {
    if (typeof v !== 'string') return '';
    // Drop control characters and angle brackets; we only ever set textContent,
    // but keep the value tidy for display.
    v = v.replace(/<[^>]*>/g, '').replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').trim();
    return v.length > max ? v.slice(0, max) : v;
  }

  function store(kind) {
    try { var s = window[kind]; var k = '__pl_t'; s.setItem(k, '1'); s.removeItem(k); return s; }
    catch (e) { return null; }
  }
  var session = store('sessionStorage');

  function sGet(key) { try { return session ? session.getItem(key) : null; } catch (e) { return null; } }
  function sSet(key, val) { try { if (session) session.setItem(key, val); } catch (e) { /* ignore */ } }

  function activeCurrency() {
    var s = window.Shopify;
    var c = s && s.currency && s.currency.active;
    if (typeof c !== 'string' || !/^[A-Z]{3}$/.test(c)) c = cfg.currency;
    return typeof c === 'string' && /^[A-Z]{3}$/.test(c) ? c : null;
  }

  function locale() {
    var l = typeof cfg.locale === 'string' ? cfg.locale : '';
    try { if (l && Intl.NumberFormat.supportedLocalesOf([l]).length) return l; } catch (e) { /* ignore */ }
    return document.documentElement.lang || undefined;
  }

  function money(cents, currency) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale(), { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(n);
    } catch (e) {
      try { return new Intl.NumberFormat(locale(), { style: 'currency', currency: currency }).format(n); }
      catch (e2) { return n.toFixed(2) + ' ' + currency; }
    }
  }

  // ----------------------------------------------------------- the marker

  function readCookie(name) {
    var parts = (document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].replace(/^\s+/, '');
      if (p.indexOf(name + '=') === 0) return p.slice(name.length + 1);
    }
    return null;
  }

  function parseJsonLoose(raw) {
    // Accept raw JSON, URL-encoded JSON, or double-encoded JSON.
    var v = raw;
    for (var i = 0; i < 3; i++) {
      try { var o = JSON.parse(v); if (typeof o === 'string') { v = o; continue; } return o; } catch (e) { /* try decoding */ }
      try { var d = decodeURIComponent(v.replace(/\+/g, ' ')); if (d === v) return null; v = d; } catch (e) { return null; }
    }
    return null;
  }

  /** Returns null (guest) or { firstName, wallet: {cents, currency, display} | null, code }. */
  function readHint() {
    var raw = readCookie('pl_hint');
    if (!raw || raw.length > 2000) return null;
    var o = parseJsonLoose(raw);
    if (!o || typeof o !== 'object' || Array.isArray(o)) return null;

    var hint = { firstName: cleanText(o.first_name, 30), wallet: null, code: null };

    var w = o.wallet;
    if (w && typeof w === 'object') {
      var amount = typeof w.amount === 'number' ? w.amount : parseFloat(String(w.amount || '').replace(/[^0-9.\-]/g, ''));
      var cur = typeof w.currency === 'string' ? w.currency.trim().toUpperCase() : '';
      if (isFinite(amount) && amount > 0 && amount < 1e7 && /^[A-Z]{3}$/.test(cur)) {
        var cents = Math.round(amount * 100);
        var display = cleanText(w.display, 24);
        // The display string must at least contain the digits of the amount;
        // otherwise format it ourselves.
        if (!display || display.replace(/[^0-9]/g, '').indexOf(String(Math.floor(amount))) === -1) display = money(cents, cur);
        hint.wallet = { cents: cents, currency: cur, display: display };
      }
    }
    if (typeof o.code === 'string' && /^[A-Za-z0-9]{1,20}$/.test(o.code)) hint.code = o.code.toUpperCase();
    return hint;
  }

  var hint = readHint();

  // ------------------------------------------------------------- header

  function initHeader() {
    if (!hint) return;
    var me = document.querySelectorAll('[data-lyne-me]');
    if (!me.length) return;
    document.querySelectorAll('[data-lyne-signin]').forEach(function (a) { a.hidden = true; });
    me.forEach(function (el) {
      var hi = el.querySelector('[data-lyne-hi]');
      if (hi) {
        if (hint.firstName) hi.textContent = 'Hi ' + hint.firstName;
        else hi.hidden = true;
      }
      el.hidden = false;
    });
  }

  // --------------------------------------------------------- plan page

  function initPlan() {
    var form = document.getElementById('ProductForm');
    if (!form || !hint || !hint.wallet) return;
    var walletBox = form.querySelector('[data-lyne-wallet]');
    var mismatchBox = form.querySelector('[data-lyne-mismatch]');
    var buy = form.querySelector('.plan-buy');
    if (!walletBox || !mismatchBox || !buy) return;

    var w = hint.wallet;
    var current = activeCurrency();
    if (!current) return;

    if (w.currency === current) {
      setupWallet(form, walletBox, buy, w, current);
    } else {
      setupMismatch(form, mismatchBox, buy, w, current);
    }
  }

  function selectedInput(form) {
    return form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
  }

  function setupWallet(form, box, buy, w, cur) {
    var link = box.querySelector('[data-lyne-app-link]');
    var alt = box.querySelector('[data-lyne-web-checkout]');
    var mainAdd = buy.querySelector('[name="add"]');
    var qty = form.querySelector('[name="quantity"]');

    function set(sel, text) { var el = box.querySelector(sel); if (el) el.textContent = text; }

    set('[data-lyne-wallet-title]', 'You have ' + w.display + ' in your ' + WALLET);
    set('[data-lyne-wallet-name]', WALLET);
    set('[data-lyne-web-note]', 'You\'ll need to sign in there to use your ' + WALLET);

    function render() {
      var input = selectedInput(form);
      var price = input ? parseInt(input.getAttribute('data-price'), 10) : NaN;
      var planId = input ? (input.getAttribute('data-plan-id') || '').trim() : '';
      if (!input || !isFinite(price) || !planId || input.disabled) {
        // No plan id or price: fall back to the normal Buy area.
        box.hidden = true; buy.hidden = false;
        return;
      }
      var off = Math.min(w.cents, price);
      var pay = price - off;
      set('[data-lyne-plan-label]', input.getAttribute('data-label') || '');
      set('[data-lyne-plan-price]', money(price, cur));
      set('[data-lyne-wallet-off]', '−' + money(off, cur));
      set('[data-lyne-pay]', money(pay, cur));
      link.textContent = 'Pay with your ' + w.display + ' ' + WALLET + ' · ' + money(pay, cur);
      link.href = APP_URL + '/checkout?plan=' + encodeURIComponent(planId) + '&from=web';
      alt.textContent = 'Check out on the website · ' + money(price, cur);
      alt.disabled = !!(mainAdd && mainAdd.disabled);
      box.hidden = false; buy.hidden = true;
    }

    // The app checkout sells one plan; keep the website path at one too.
    if (qty) qty.value = '1';
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') render();
    });
    render();
  }

  function pickCountry(currency) {
    var list = [];
    try {
      var el = document.getElementById('LyneCountries');
      if (el) list = JSON.parse(el.textContent) || [];
    } catch (e) { list = []; }
    var matches = list.filter(function (x) { return x && x.cur === currency && /^[A-Z]{2}$/.test(x.c); });
    if (!matches.length) return null;
    // Prefer the country the currency is named after (GB for GBP, NG for NGN).
    var home = currency.slice(0, 2);
    for (var i = 0; i < matches.length; i++) if (matches[i].c === home) return matches[i].c;
    var prefer = { EUR: ['IE', 'DE', 'FR', 'NL', 'ES', 'IT'] }[currency] || [];
    for (var j = 0; j < prefer.length; j++) {
      for (var k = 0; k < matches.length; k++) if (matches[k].c === prefer[j]) return matches[k].c;
    }
    return matches[0].c;
  }

  function setupMismatch(form, box, buy, w, cur) {
    var key = 'pl_wallet_skip_' + w.currency + '_' + cur;
    if (sGet(key)) return; // They chose to continue without it this session.

    var sw = box.querySelector('[data-lyne-switch]');
    var cont = box.querySelector('[data-lyne-continue]');
    var country = pickCountry(w.currency);

    function set(sel, text) { var el = box.querySelector(sel); if (el) el.textContent = text; }
    set('[data-lyne-mismatch-title]', 'Your ' + w.display + ' ' + WALLET + ' is in ' + w.currency + '. Switch to ' + w.currency + ' to use it.');
    set('[data-lyne-mismatch-text]', country
      ? 'Your ' + WALLET + ' can only be spent in the currency it\'s in. Your card can still pay in ' + w.currency + ' while you\'re abroad.'
      : 'Your ' + WALLET + ' can only be spent in the currency it\'s in. You can use it in the Phonelyne app.');
    set('[data-lyne-mismatch-note]', 'Your ' + w.display + ' stays in your account either way.');

    if (country && sw && document.getElementById('LyneCurrencyForm')) {
      sw.value = country;
      sw.textContent = 'Switch to ' + w.currency;
    } else if (sw) {
      sw.hidden = true;
    }
    cont.textContent = 'Continue in ' + cur + ' without it';
    cont.addEventListener('click', function () {
      sSet(key, '1');
      box.hidden = true; buy.hidden = false;
      var add = buy.querySelector('[name="add"]');
      if (add) add.focus();
    });
    box.hidden = false; buy.hidden = true;
  }

  // ------------------------------------------------------ referral banner

  var REF_KEY = 'pl_ref';
  var REF_DISMISSED = 'pl_ref_dismissed';

  function firstNameFrom(data) {
    if (!data || typeof data !== 'object') return '';
    var cands = [
      data.first_name, data.referrer_first_name,
      data.referrer && data.referrer.first_name,
      data.data && data.data.first_name,
      data.data && data.data.referrer_first_name,
      data.data && data.data.referrer && data.data.referrer.first_name
    ];
    for (var i = 0; i < cands.length; i++) {
      var n = cleanText(cands[i], 30);
      if (n) return n;
    }
    return '';
  }

  function lookupCode(code) {
    if (!API_URL || !window.fetch) return Promise.resolve({ ok: false });
    var ctrl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 4000);
    return fetch(API_URL + '/rewards/codes/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'omit',
      headers: { 'Accept': 'application/json' },
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      clearTimeout(t);
      if (r.status === 404 || r.status === 410) return { ok: true, unknown: true };
      if (!r.ok) return { ok: false };
      return r.json().then(function (d) {
        if (d && (d.valid === false || d.active === false)) return { ok: true, unknown: true };
        return { ok: true, name: firstNameFrom(d) };
      }, function () { return { ok: false }; });
    }, function () { clearTimeout(t); return { ok: false }; });
  }

  function showBanner(ref) {
    if (sGet(REF_DISMISSED) === ref.code) return;
    var text = ref.name
      ? ref.name + ' gave you 10% off your first eSIM. Applied at checkout.'
      : 'Your 10% off is applied at checkout.';

    var bar = document.createElement('div');
    bar.className = 'lyne-ann';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<div class="lyne-ann__inner">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M12 8c-2-4-6-4-6-1s6 1 6 1zm0 0c2-4 6-4 6-1s-6 1-6 1z"/></svg>' +
      '<span data-lyne-ann-text></span></div>' +
      '<button type="button" class="lyne-ann__close" aria-label="Dismiss">×</button>';
    bar.querySelector('[data-lyne-ann-text]').textContent = text;
    bar.querySelector('.lyne-ann__close').addEventListener('click', function () {
      sSet(REF_DISMISSED, ref.code);
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
    document.body.insertBefore(bar, document.body.firstChild);

    var chip = document.querySelector('[data-lyne-ref-chip]');
    if (chip) {
      chip.textContent = ref.name ? '10% off from ' + ref.name + ' · code ' + ref.code : '10% off · code ' + ref.code;
      chip.hidden = false;
    }
  }

  function initReferral() {
    var code = null;
    try { code = new URLSearchParams(window.location.search).get('ref'); } catch (e) { code = null; }
    code = code && /^[A-Za-z0-9]{1,20}$/.test(code) ? code.toUpperCase() : null;

    var saved = null;
    try { saved = JSON.parse(sGet(REF_KEY) || 'null'); } catch (e) { saved = null; }
    if (saved && (typeof saved.code !== 'string' || !/^[A-Z0-9]{1,20}$/.test(saved.code))) saved = null;
    if (saved) saved.name = cleanText(saved.name, 30);

    // Your own link: nothing to welcome.
    if (code && hint && hint.code === code) return;

    if (!code) { if (saved) showBanner(saved); return; }
    if (saved && saved.code === code) { showBanner(saved); return; }

    lookupCode(code).then(function (res) {
      if (res.unknown) return; // Not a referral code: no discount to announce.
      var ref = { code: code, name: res.ok ? res.name : '' };
      sSet(REF_KEY, JSON.stringify(ref));
      showBanner(ref);
    });
  }

  // ------------------------------------------------------------------ go

  function run() {
    initHeader();
    initPlan();
    initReferral();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Exposed for the test harness and support debugging only. Display data.
  window.PhonelyneLyne = { readHint: readHint };
})();
